import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["sidebar", "main"];

  connect() {
    this.updateState();
  }

  toggle(event) {
    if (event) event.preventDefault();
    
    const isCollapsed = this.sidebarTarget.classList.contains("is-collapsed");
    if (isCollapsed) {
      this.expand();
    } else {
      this.collapse();
    }
  }

  collapse() {
    this.sidebarTarget.classList.add("is-collapsed");
    this.mainTarget.classList.add("is-expanded");
    this.setCookie("pool_sidebar_visible", "false", 30);
  }

  expand() {
    this.sidebarTarget.classList.remove("is-collapsed");
    this.mainTarget.classList.remove("is-expanded");
    this.setCookie("pool_sidebar_visible", "true", 30);
  }

  updateState() {
    const visible = this.getCookie("pool_sidebar_visible") !== "false";
    if (visible) {
      this.expand();
    } else {
      this.collapse();
    }
  }

  setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
}
